import React from 'react';
//import ReactDOM from 'react-dom/client';
import './index.css';
import ReactDOM from 'react-dom';
import { AppProvider } from './context';
import App from './menu/App';

import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>
);

// ReactDOM.render(
//   <React.StrictMode>
//     <AppProvider>
//       <App />
//     </AppProvider>
//   </React.StrictMode>,
//   document.getElementById('root')
// );
